/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ClaimChatInvitationsResponse = zod.object({
  claimed: zod
    .array(
      zod.object({
        threadId: zod.string(),
      }),
    )
    .describe(
      'Reach thread ids the caller was just seated into. The App refreshes its thread list for these.',
    ),
});

export type ClaimChatInvitationsResponse = zod.input<typeof ClaimChatInvitationsResponse>;
export type ClaimChatInvitationsResponseOutput = zod.output<typeof ClaimChatInvitationsResponse>;
